var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{staticClass:"fal",class:_vm.faIconClass,staticStyle:{"cursor":"pointer","font-size":"4vw"},on:{"click":_vm.handleClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }